import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TDownloadLaborPosterRequestSchema,
  TDownloadLaborPosterResponseSchema,
} from "./downloadLaborPoster.schema";
import { IApiResponse } from "clients/AbstractApiClient/IApiResponse";

export const downloadLaborPoster = (axios: IAxiosInstance) => {
  return async ({
    labor_poster_id,
    labor_poster_version_id,
  }: TDownloadLaborPosterRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TDownloadLaborPosterResponseSchema>
    >(`/labor-posters/${labor_poster_id}/download`, {
      params: {
        labor_poster_version_id,
      },
    });
    return response.data;
  };
};
